import { supabase } from "./supabase";
import type { ApiEnvelope } from "@/types/api";

const baseUrl = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly status: number, public readonly requestId?: string) { super(message); }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<ApiEnvelope<T>> {
  const { data: { session } } = await supabase.auth.getSession();
  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}), ...init.headers },
  });
  const payload = await response.json() as ApiEnvelope<T>;
  if (!response.ok || payload.error) throw new ApiError(payload.error?.code || "REQUEST_FAILED", payload.error?.message || "The request failed.", response.status, payload.meta?.requestId);
  return payload;
}
